import { $authHost } from "./index";
import { jwtDecode } from "jwt-decode";

const getTokenUserId = () => {
    try {
        const token = localStorage.getItem("token");
        return token ? Number(jwtDecode(token)?.id) : null;
    } catch (_) {
        return null;
    }
};

const scopedPath = (basePath, userId) => {
    const tokenUserId = getTokenUserId();
    return tokenUserId && Number(userId) === tokenUserId
        ? `${basePath}/me`
        : `${basePath}/${userId}`;
};

export const createPool = async (poolData) => {
    const { data } = await $authHost.post("api/pool", poolData);
    return data;
};

export const updatePool = async (poolData) => {
    const { data } = await $authHost.post("api/pool/update", poolData);
    return data;
};

export const getPoolsCurrentUser = async (userId) => {
    const { data } = await $authHost.get(`api/${scopedPath("pool", userId)}`);
    return data;
};

export const createPoolItems = async (poolItemsData) => {
    const { data } = await $authHost.post("api/pool_item", poolItemsData);
    return data;
};

export const getPollItemsLibrary = async (_userId, language, pollType, limit, page) => {
    const { data } = await $authHost.get("/api/pool_item/af", {
        params: {
            language,
            pollType,
            limit,
            page,
        },
    });
    return data;
};

export const updatePoolItem = async (poolItemData) => {
    const { data } = await $authHost.post("api/pool_item/update", poolItemData);
    return data;
};

export const getPollItemsCurrentUser = async (userId) => {
    const { data } = await $authHost.get(`api/pool_item/${scopedPath("user", userId)}`);
    return data;
};

export const getItemsCurrentPoll = async (pollId) => {
    const { data } = await $authHost.get(`api/pool_item/pi/${pollId}`);
    return data;
};
